import React, { useEffect, useState } from "react"
import AuthService from "../../services/AuthService";
import { myroutes } from "../../routes/webroute";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { authCheck } from "../../services/http";
import { useDispatch, useSelector } from "react-redux";
import { checkAuthenticate, resetAuthData } from "../../app/providers/authSlice";
import Logout, { logoutRequest } from "../auth/logout";

export default function TopBar() {

	const navigate = useNavigate()
	const auth = useSelector(state => state.auth)
	const dispatch = useDispatch()

	// check if user is authenticate
	dispatch(checkAuthenticate())

	// Vérifier si le token existe et n'est pas expiré 
	if (!auth.isAuthenticate) {
		//deconnecter l'utilisateur et renvoie sur login page 
		dispatch(resetAuthData())
		navigate(myroutes.login)
	}

	useEffect(() => {

	}, [navigate]);

	// se déconnecter
	const handleLogout = () => {
		logoutRequest(auth.token);
		dispatch(resetAuthData());
	}

	//Afficher les détails du profil
	const monProfil = () => {
		navigate(myroutes.profil_user)
	}

	//Editer le profil
	const editProfil = () => {
		navigate(myroutes.profil_edit)
	}

	return (
		<React.Fragment>
			<div className="app-header-inner">
				<div className="container-fluid py-2">
					<div className="app-header-content">
						<div className="row justify-content-between align-items-center">
							<div className="col-auto">
								<a id="sidepanel-toggler" className="sidepanel-toggler d-inline-block d-xl-none" href="#">
									<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"
										role="img">
										<title>Menu</title>
										<path stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10"
											strokeWidth="2" d="M4 7h22M4 15h22M4 23h22"></path>
									</svg>
								</a>
							</div>{/*//col*/}

							<div className="app-utilities col-auto">

								<div className="app-utility-item app-user-dropdown dropdownx">

									<Link className="dropdown-toggle" id="user-dropdown-toggle" data-bs-toggle="dropdown" to={"#"}
										role="button" aria-expanded="false"><i className="fas fa-user"></i>&nbsp; {auth.user?.prenoms}  {auth.user?.nom} </Link>
									<ul className="dropdown-menu" aria-labelledby="user-dropdown-toggle">
										<li><a onClick={() => monProfil()} className="dropdown-item" href="#">Mon profil</a></li>
										<li><a onClick={() => editProfil()} className="dropdown-item" href="#">Editer profil</a></li>
										<li>
											<hr className="dropdown-divider" />
										</li>
										<li><a className="dropdown-item" href="#" onClick={() => handleLogout()}>Se deconnecter</a></li>
									</ul>
								</div>{/*//app-user-dropdown*/}
							</div>{/*//app-utilities*/}
						</div>{/*//row*/}
					</div>{/*//app-header-content*/}
				</div>{/*//container-fluid*/}
			</div>{/*//app-header-inner*/}
		</React.Fragment>
	)
}